import React from "react";
import { Document, Page, Text, View, StyleSheet, Image, Font, Svg, Path } from "@react-pdf/renderer";
import { formatCurrency } from "../../../Constants";

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

// Define styles for the PDF
const styles = StyleSheet.create({
    page: {
        // padding: 20,
        fontFamily: "Oswald", // Use the registered font
        color: "black",
        position: "relative",
    },
    header: {
        fontSize: 20,
        textAlign: "center",
        marginBottom: 20,
    },
    section: {
        fontSize: 12,
        padding: 10,
    },
    row: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        // marginTop: 20,
    },
    image: {
        width: "45%",
        height: "auto",
    },
    bannerImageContainer: {
        width: "100%",
        height: 300,
        backgroundColor: "#f0f0f0", // Placeholder for the image background
        position: "relative",
    },
    bannerImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    wordmark: {
        height: 50,
        width: 150,
    },
});

const eventFormatMap = {
    "": "",
    "national": "National Event",
    "area": "Area Event",
    "pc": "Porsche Center Event",
}
const eventTypeMap = {
    "": "",
    "launch": "Launch",
    "nosub": "There is no substitute",
    "driving": "Driving",
    "place": "PLACE",
    "performance": "Performance",
    "crc": "Classic Restoration Challenge",
    "motorsport": "Motorspot (PCNA Hosted)",
}
const targetAudienceMap = {
    "": "",
    "women": "Driven Women",
    "core": "Driven Core",
    "youth": "Driven Youth",
    "conquest": "Conquest",
}
const attendeeMap = {
    "": "",
    "prospects": "Prospects",
    "mix": "Mix",
    "current": "Current Customers",
}

const vehicleMap = {
    "911": "911",
    "718": "718",
    "boxster": "Boxster",
    "cayman": "Cayman",
    "cayenne": "Cayenne",
    "cayenne electric": "Cayenne Electric",
    "macan": "Macan",
    "macan electric": "Macan Electric",
    "panamera": "Panamera",
    "taycan": "Taycan",
};

// PDF Template Component
const EventRecapPDF = ({ row }) => {
    // Helper function to split gallery images into chunks of 8
    const chunkGalleryImages = (images, chunkSize = 8) => {
        const chunks = [];
        for (let i = 0; i < images.length; i += chunkSize) {
            chunks.push(images.slice(i, i + chunkSize));
        }
        return chunks;
    };

    // Exclude the first 3 images and split the remaining images into pages
    const galleryPages = chunkGalleryImages((row.galleryImages || []).slice(3), 8);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                    <Svg style={styles.wordmark} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4500 300"><Path d="M502 221c48.1 0 74-25.9 74-74V74c0-48.1-25.9-74-74-74H0v300h68v-79h434zm6-143v65c0 7.8-4.2 12-12 12H68V66h428c7.8 0 12 4.2 12 12zm228 222c-48.1 0-74-25.9-74-74V74c0-48.1 25.9-74 74-74h417c48.1 0 74 25.9 74 74v152c0 48.1-25.9 74-74 74H736zm411-66c7.8 0 12-4.2 12-12V78c0-7.8-4.2-12-12-12H742c-7.8 0-12 4.2-12 12v144c0 7.8 4.2 12 12 12h405zm675-36c39.844 16.757 67.853 56.1 68 102h-68c0-54-25-79-79-79h-361v79h-68V0h502c48.1 0 74 25.9 74 74v50.14c0 46.06-23.75 71.76-68 73.86zm-12-43c7.8 0 12-4.2 12-12V78c0-7.8-4.2-12-12-12h-428v89h428zm162-81c0-48.1 25.9-74 74-74h492v56h-486c-7.8 0-12 4.2-12 12v42c0 7.8 4.2 12 12 12h422c48.1 0 74 25.9 74 74v30c0 48.1-25.9 74-74 74h-492v-56h486c7.8 0 12-4.2 12-12v-42c0-7.8-4.2-12-12-12h-422c-48.1 0-74-25.9-74-74V74zm661 0c0-48.1 25.9-74 74-74h480v66h-474c-7.8 0-12 4.2-12 12v144c0 7.8 4.2 12 12 12h474v66h-480c-48.1 0-74-25.9-74-74V74zM3817 0v300h-68V183h-407v117h-68V0h68v117h407V0h68zm156 56v66h527v56h-527v66h527v56h-595V0h595v56h-527z" fill="black"></Path></Svg>
                </View>
                <View style={[styles.row, styles.bannerImageContainer]}>
                    {row.galleryImages?.[0]?.preview && (
                        <Image src={row.galleryImages[0].preview} style={styles.bannerImage} />
                    )}
                </View>
                <View style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <View style={[styles.section, { flex: '0 0 530px', height: '100%' }]}>
                        <Text style={{ fontWeight: "bold" }}>{row.sysname || ""}</Text>
                        <Text style={{ fontWeight: "bold" }}>{[eventFormatMap[row.eventFormat] || "", eventTypeMap[row.eventType] || ""].filter(ele => ele).join(" | ")}</Text>
                        <Text style={{ fontWeight: "bold" }}>{row.eventLocation || ""}</Text>
                        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: '100%', marginTop: 20 }}>
                            {/* <Text>{JSON.stringify(row)}</Text> */}


                            {row.eventBudget && (
                                <View style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text>{formatCurrency(row.eventBudget)}</Text>
                                    <Text>{"BUDGET"}</Text>
                                </View>
                            )}
                            {row.eventSales && (
                                <View style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text>{formatCurrency(row.eventSales)}</Text>
                                    <Text>{"SALES"}</Text>
                                </View>
                            )}
                            {row.leads && (
                                <View style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text>{row.leads.length}</Text>
                                    <Text>{"LEADS"}</Text>
                                </View>
                            )}
                            {row.attendance && (
                                <View style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text>{row.attendance || "0"}</Text>
                                    <Text>{"ATTENDANCE"}</Text>
                                </View>
                            )}
                            {row.testdrivecount && (
                                <View style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Text>{row.testdrivecount || "0"}</Text>
                                    <Text>{"DRIVES"}</Text>
                                </View>
                            )}
                        </View>
                        <View style={{ display: "flex", flexDirection: "row", marginTop: 20 }}>
                            <View style={{ width: "50%", display: "flex", flexDirection: "column", gap: 10 }}>
                                <View>
                                    <Text>{row.eventLocation || ""}</Text>
                                    <Text>{[row.eventCity || "", row.state].filter(ele => ele).join(", ")}</Text>
                                </View>
                                <View>
                                    {row.attendance &&
                                        <Text>Attendees: {row.attendance}</Text>
                                    }
                                    {row.aboutattendees &&
                                        <Text>About Attendees: {attendeeMap[row.aboutattendees]}</Text>
                                    }
                                    {row.targetaudience &&
                                        <Text>Target Audience: {targetAudienceMap[row.targetaudience]}</Text>
                                    }
                                </View>
                                <View>
                                    {row.giveawayitems && <Text>Giveaways: {row.giveawayitems}</Text>}
                                </View>
                            </View>
                            <View style={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 10 }}>
                                <View style={{ border: "1px solid grey", padding: 10, borderRadius: 8, boxSizing: "border-box" }}>
                                    {(row?.vehicleshighlighted || []).length > 0 ? (
                                        (row?.vehicleshighlighted || []).length > 4 ? (
                                            // Two columns with better spacing
                                            <View style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                                <View style={{ flex: 1 }}>
                                                    {(row.vehicleshighlighted || [])
                                                        .filter((_, index) => index % 2 === 0)
                                                        .map((vehicle, index) => (
                                                            <Text key={index}>{vehicleMap[vehicle] || vehicle}</Text>
                                                        ))}
                                                </View>
                                                <View style={{ flex: 1 }}>
                                                    {(row.vehicleshighlighted || [])
                                                        .filter((_, index) => index % 2 === 1)
                                                        .map((vehicle, index) => (
                                                            <Text key={index}>{vehicleMap[vehicle] || vehicle}</Text>
                                                        ))}
                                                </View>
                                            </View>
                                        ) : (
                                            // Single column for 4 or fewer items
                                            (row.vehicleshighlighted || []).map((vehicle, index) => (
                                                <Text key={index}>{vehicleMap[vehicle] || vehicle}</Text>
                                            ))
                                        )
                                    ) : (
                                        <Text>No vehicles highlighted</Text>
                                    )}
                                </View>
                                <Text>{row.electrictrims}</Text>
                                {row.vehiclecount && <Text>Vehicle Count: {row.vehiclecount}</Text>}
                                <View>
                                    {
                                        row.externalgallery &&
                                        (<Text>Photos: {row.externalgallery}</Text>)
                                    }
                                    {
                                        row.videoLink &&
                                        (<Text>Video: {row.videoLink}</Text>)
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{ width: "100%", display: "flex", flexDirection: "row", height: 152, flexShrink: 0 }}>
                        <View style={{ flex: "1" }}>
                            <Image src={row?.galleryImages[1]?.preview || ""} style={styles.bannerImage} />
                        </View>
                        <View style={{ flex: "1" }}>
                            <Image src={row?.galleryImages[2]?.preview || ""} style={styles.bannerImage} />
                        </View>
                    </View>
                </View>
            </Page>
            {/* Additional Pages for Gallery Images */}
            {galleryPages.map((images, pageIndex) => (
                <Page key={pageIndex} size="A4" style={styles.page}>
                    <View style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                        <Svg style={styles.wordmark} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4500 300"><Path d="M502 221c48.1 0 74-25.9 74-74V74c0-48.1-25.9-74-74-74H0v300h68v-79h434zm6-143v65c0 7.8-4.2 12-12 12H68V66h428c7.8 0 12 4.2 12 12zm228 222c-48.1 0-74-25.9-74-74V74c0-48.1 25.9-74 74-74h417c48.1 0 74 25.9 74 74v152c0 48.1-25.9 74-74 74H736zm411-66c7.8 0 12-4.2 12-12V78c0-7.8-4.2-12-12-12H742c-7.8 0-12 4.2-12 12v144c0 7.8 4.2 12 12 12h405zm675-36c39.844 16.757 67.853 56.1 68 102h-68c0-54-25-79-79-79h-361v79h-68V0h502c48.1 0 74 25.9 74 74v50.14c0 46.06-23.75 71.76-68 73.86zm-12-43c7.8 0 12-4.2 12-12V78c0-7.8-4.2-12-12-12h-428v89h428zm162-81c0-48.1 25.9-74 74-74h492v56h-486c-7.8 0-12 4.2-12 12v42c0 7.8 4.2 12 12 12h422c48.1 0 74 25.9 74 74v30c0 48.1-25.9 74-74 74h-492v-56h486c7.8 0 12-4.2 12-12v-42c0-7.8-4.2-12-12-12h-422c-48.1 0-74-25.9-74-74V74zm661 0c0-48.1 25.9-74 74-74h480v66h-474c-7.8 0-12 4.2-12 12v144c0 7.8 4.2 12 12 12h474v66h-480c-48.1 0-74-25.9-74-74V74zM3817 0v300h-68V183h-407v117h-68V0h68v117h407V0h68zm156 56v66h527v56h-527v66h527v56h-595V0h595v56h-527z" fill="black"></Path></Svg>
                    </View>
                    <View style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", boxSizing: "border-box", rowGap: 10 }}>
                        {images.map((image, index) => (
                            <View key={index} style={{ width: "50%" }}>
                                <Image src={image.preview} style={{ width: "100%", height: 152, objectFit: "cover" }} />
                            </View>
                        ))}
                    </View>
                </Page>
            ))}
        </Document>
    );
};

export default EventRecapPDF;